import { render } from "./ListGoal.vue?vue&type=template&id=6fb0b8bf"
import script from "./ListGoal.vue?vue&type=script&lang=js"
export * from "./ListGoal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__